<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" flat icon>
        <img v-if="selectedLanguage.flag" :src="selectedLanguage.flag" :alt="selectedLanguage.name" width="20" height="20" />
      </v-btn>
    </template>
    <v-list class="language--menu-color">
      <v-list-tile
        v-for="(language, index) in languages"
        :key="index"
        avatar
        @click="selectLanguage(language)"
      >
        <v-list-tile-content>
          <v-list-tile-title>{{ language.name }}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <img :src="language.flag" :alt="language.name" width="20" height="20" />
        </v-list-tile-action>

      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import i18n from '@/plugins/i18n';
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      menu: false,
      languages: [
        {
          name: 'English',
          flag: require('../../assets/country_flags/united-states.svg'),
          value: 'en'
        },
        {
          name: 'Français',
          flag: require('../../assets/country_flags/france-flag.svg'),
          value: 'fr'
        }
      ],
      selectedLanguage: {
        name: 'English',
        flag: require('../../assets/country_flags/united-states.svg'),
        value: 'en'
      }
    };
  },
  computed: {
    ...mapGetters([
      "getGeneralState"
    ]),
  },
  mounted() {
    this.selectedLanguage = this.languages.filter(el => el.value == this.getGeneralState('language'))[0]
    i18n.locale = this.selectedLanguage.value
  },
  methods: {
    ...mapMutations([
      "SET_LANGUAGE"
    ]),
    selectLanguage(language) {
      this.selectedLanguage = language;
      i18n.locale = language.value;
      this.SET_LANGUAGE(language.value)
      this.menu = false;
    }
  }
};
</script>

<style scoped>
  .language--menu-color {
    background: var(--v-bg-base);
  }
</style>
